import { render, staticRenderFns } from "./reg-set-password.vue?vue&type=template&id=bef5ef42&"
import script from "./reg-set-password.vue?vue&type=script&lang=js&"
export * from "./reg-set-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports